<template>
  <div class="b-contracts__paging px-6 py-2">
    <div class="col-2 pl-0 b-contracts__paging-block b-contracts__paging-page-info">
      <button class="b-btn b-btn_type_arrow b-contracts__paging-arrow mr-3" :disabled="isDisabledPrevClick" @click="showPrevPageNumber">
        <dynamic-icon icon="arrow-left"></dynamic-icon>
      </button>
      <numeric class="b-numeric b-contracts__paging-page-num" :min="1" :max="pageCount" v-model.lazy="filterParams.page" @keypress="changeNumericValue($event)"></numeric>


      <button class="b-btn b-btn_type_arrow b-contracts__paging-arrow ml-3" :disabled="isDisabledNextClick" @click="showNextPageNumber">
        <dynamic-icon icon="arrow-right"></dynamic-icon>
      </button>
      <div class="ml-4">{{$t('CONTENT.paging.page_count_from')}}</div>
      <div class="ml-1">{{pageCount}}</div>
    </div>
    <div class="col-3 b-contracts__paging-block b-contracts__paging-page-info b-contracts__paging-page-info_type_justify_end">
      <div>{{$t('CONTENT.paging.shown')}}</div>
      <div class="pl-1 b-contracts__paging-range">{{countRange}}</div>
      <div class="mx-1">{{$t('CONTENT.paging.page_count_from')}}</div>
      <div>{{totalCount}}</div>
    </div>
  </div>
</template>

<script>
	import changeNumericValue from "../../../mixins/changeNumericValue";

  export default {
	  props: {
      contractsWithErrorCount: {
        type: Number,
      },
      contractsCount: {
        type: Number,
      },
      currentContractType: {
        type: String,
      },
      filterParams: {
        type: Object,
      },
      totalCount: {
        type: Number,
      }
    },
    mixins: [changeNumericValue],
    data() {
      return {
        countRange: null,
      }
    },
    async created() {
	    this.loadNeededContracts();
    },
    computed: {
      pageCount() {
        return Math.ceil(this.totalCount / this.filterParams.itemsPerPage);
      },
      isDisabledPrevClick() {
        return this.filterParams.page <= 1;
      },
      isDisabledNextClick() {
        return this.filterParams.page >= this.pageCount;
      },
    },
    watch: {
	    'contractsCount'(newVal) {
        let startItemNum = this.filterParams.page * this.filterParams.itemsPerPage - (this.filterParams.itemsPerPage - 1);
        let endItemNum = startItemNum + (newVal + this.contractsWithErrorCount - 1);
        this.countRange = `${startItemNum} - ${endItemNum}`;
      },
      'filterParams': {
        handler() {
          this.loadNeededContracts();
        },
        deep: true,
      }
    },
    methods: {
      showPrevPageNumber() {
        if(this.filterParams.page > 1) {
          this.filterParams.page -= 1;
        }
      },
      showNextPageNumber() {
        if(this.filterParams.page < this.totalCount) {
          this.filterParams.page += 1;
        }
      },
      async loadNeededContracts() {
        this.$emit('getContractsByPaging');
      },
    }
  }
</script>
